"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _DragHandle = _interopRequireDefault(require("@paprika/icon/lib/DragHandle"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _Trashbin = _interopRequireDefault(require("@paprika/icon/lib/Trashbin"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _SortableItem = require("./SortableItem.styles");

var propTypes = {
  children: _propTypes["default"].node.isRequired,

  /** Handle element, default is a handle icon */
  handleElement: _propTypes["default"].node,

  /** Indicator to identify the number sequence  */
  hasNumbers: _propTypes["default"].bool.isRequired,

  /** Numerical representation of an item */
  index: _propTypes["default"].number.isRequired,

  /** If drag action should be disabled on an item */
  isDragDisabled: _propTypes["default"].bool,

  /** Callback when deleting an item */
  onRemove: _propTypes["default"].func
};
var defaultProps = {
  handleElement: /*#__PURE__*/_react["default"].createElement(_DragHandle["default"], null),
  isDragDisabled: false,
  onRemove: null
};

var _StyledLi = (0, _styledComponents["default"])("li").withConfig({
  displayName: "SortableItem___StyledLi",
  componentId: "xm42sh-0"
})(["", ""], _SortableItem.itemStyles);

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "SortableItem___StyledDiv",
  componentId: "xm42sh-1"
})(["", ""], _SortableItem.itemHandleStyles);

var _StyledDiv2 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "SortableItem___StyledDiv2",
  componentId: "xm42sh-2"
})(["", ""], _SortableItem.itemIndexStyles);

var _StyledDiv3 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "SortableItem___StyledDiv3",
  componentId: "xm42sh-3"
})(["", ""], _SortableItem.itemBodyStyles);

var _StyledDiv4 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "SortableItem___StyledDiv4",
  componentId: "xm42sh-4"
})(["", ""], _SortableItem.itemCloseStyles);

var SortableItem = function SortableItem(_ref) {
  var children = _ref.children,
      index = _ref.index,
      handleElement = _ref.handleElement,
      hasNumbers = _ref.hasNumbers,
      isDragDisabled = _ref.isDragDisabled,
      onRemove = _ref.onRemove,
      moreProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "index", "handleElement", "hasNumbers", "isDragDisabled", "onRemove"]);
  var I18n = (0, _useI18n["default"])();

  var handleRemove = function handleRemove() {
    onRemove(index);
  };

  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
    draggableId: "draggable-".concat(children.props.sortId),
    index: index,
    isDragDisabled: isDragDisabled
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement(_StyledLi, (0, _extends2["default"])({}, provided.draggableProps, provided.dragHandleProps, {
      "data-pka-anchor": "sortable.item",
      "data-is-dragging": snapshot.isDragging ? true : undefined,
      isDragging: snapshot.isDragging,
      ref: provided.innerRef
    }, moreProps), /*#__PURE__*/_react["default"].createElement(_StyledDiv, {
      "data-pka-anchor": "sortable.item.handle"
    }, handleElement), hasNumbers && /*#__PURE__*/_react["default"].createElement(_StyledDiv2, {
      "data-pka-anchor": "sortable.item.number"
    }, index + 1), /*#__PURE__*/_react["default"].createElement(_StyledDiv3, {
      "data-pka-anchor": "sortable.item.body"
    }, children), onRemove && /*#__PURE__*/_react["default"].createElement(_StyledDiv4, {
      "data-pka-anchor": "sortable.item.remove"
    }, /*#__PURE__*/_react["default"].createElement(_button["default"].Icon, {
      onClick: handleRemove,
      kind: _button["default"].Icon.types.kind.MINOR,
      size: _button["default"].Icon.types.size.MEDIUM,
      a11yText: I18n.t("sortable.aria_remove")
    }, /*#__PURE__*/_react["default"].createElement(_Trashbin["default"], {
      color: _tokens["default"].color.blackLighten20
    }))));
  });
};

SortableItem.displayName = "SortableItem";
SortableItem.propTypes = propTypes;
SortableItem.defaultProps = defaultProps;
var _default = SortableItem;
exports["default"] = _default;
//# sourceMappingURL=SortableItem.js.map